




































































import {
  watch,
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs,
  getCurrentInstance,
  ComponentInternalInstance,
  onUnmounted,
} from '@vue/composition-api';
import { InfoCircleIcon } from 'tdesign-icons-vue';
import dayjs from 'dayjs';

// 引入组件
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import FileIcon from '@/renderer/components/Base/BaseTableFileIcon/FileIcon.vue';
import { i18n_t } from '@/locales/i18n';

// 引入 compositions
import detailHandler, { BaseDetailType, DetailType } from '@/renderer/components/SpacePage/compositions/detailHandler';

// 引入工具类
import { optAuth } from '@/renderer/scripts/composition/authHandler';
import { formatSize, formatType, getSpaceDirectory, getNameTipsDetail } from '@/renderer/scripts/utils/tools/index';
import { SMH } from '@/renderer/scripts/smh';
import { isAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import { SEARCH_TYPE_MAP } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
function formatSizeString(itemSize?: string) {
  const { size, unit } = formatSize(itemSize as string);
  return `${size} ${unit}`;
}
export default defineComponent({
  name: 'FileInfo',
  components: {
    StatusTag,
    InfoCircleIcon,
    FileIcon,
  },
  props: {
    spaceId: {
      type: String,
      default: '',
    },
    params: {
      required: true,
      type: Object as () => SMH.getDirectoryOrFileInfoData,
    },
    isHistoryVersion: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formatFileType(key: string) {
      const fileType: Record<string, string> = SEARCH_TYPE_MAP;
      return fileType[key] || key;
    },
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const { $route } = vm;
    const showTips = ref(false);
    let showNum = 0;
    // 解构 props
    const { spaceId, params, isHistoryVersion: historyVersion } = toRefs(props);
    const isExternalFile = computed(
      () => vm.$store.state.drawer.spaceOrgId && vm.$store.state.drawer.spaceOrgId !== vm.$store.getters.orgId,
    );
    const innerSpaceId = ref('');
    const {
      methods: detailMethods,
      detailData,
      initWord,
      loading: detailLoading,
      userData,
    } = detailHandler(innerSpaceId);
    const chooseWord = ref('');
    // 空间列表的详情不展示团队名称
    const isPreview = computed(() => $route.path?.includes('preview'));
    /**
     * 可疑（病毒/敏感）文件允许信任：
     * 根据后端返回的canMarkAsNonSensitiveWord和canMarkAsNonVirus字段来判断
     * 可疑（病毒/敏感）文件不允许加白：工作台路由 & 个人空间 & 预览编辑
     */
    const closeable = computed(() => {
      const data = detailData.value as SMH.getDirectoryOrFileInfoData;
      const canTrust =
        (params.value.virusAuditStatus === 3 && data.canMarkAsNonVirus === true) ||
        (params.value.sensitiveWordAuditStatus === 2 && data.canMarkAsNonSensitiveWord === true);
      const inRoute = $route.path?.includes('workbench') || $route.name?.startsWith('personalSpace') || isPreview.value;
      return canTrust && !inRoute;
    });
    const detailItem = computed(() => {
      const data = detailData.value as SMH.getDirectoryOrFileInfoData;
      if (Object.keys(data).length === 0) return {};
      const sizeValue = data.historySize
        ? i18n_t('{slot1} (历史版本 {slot2})', {
            slot1: formatSizeString(data.size),
            slot2: formatSizeString(String(data.historySize)),
          })
        : formatSizeString(data.size);
      const spaceStr = getSpaceDirectory(data);
      const pathStr = `${data.path?.slice(0, data.path?.length - 1).join('/')}`;

      return {
        ...data,
        type: formatType(data.type),
        size: data.type !== 'dir' ? sizeValue : '-',
        creationTime: dayjs(data.creationTime).format('YYYY-MM-DD HH:mm:ss'),
        modificationTime: dayjs(data.modificationTime).format('YYYY-MM-DD HH:mm:ss'),
        space: spaceStr,
        path: pathStr,
      };
    });
    const methods = {
      onError(event: any) {
        const img = event.srcElement;
        img.src = require('@/renderer/assets/images/Icon/new-icon/file_image.svg');
      },
      adaptCreater(key: string, val: string, item: SMH.SpaceFileItemData) {
        if (key === 'creationPerson') {
          return optAuth('Edit', item) ? i18n_t('更新人') : i18n_t('创建人');
        }
        return val;
      },
      initData() {
        innerSpaceId.value = spaceId.value;
        if (!spaceId.value) {
          innerSpaceId.value = spaceId.value;
        }
        detailMethods.getDetailData(params.value);
      },
      clickText(text: string) {
        if (vm.$route.name !== 'edit') return;
        chooseWord.value = text;
        methods.changeHighLightText(text);
      },
      changeHighLightText(text: string) {
        const data = detailData.value as SMH.getDirectoryOrFileInfoData;
        // 外部群组所在的企业不是自己的企业，编辑的时候就不显示
        if (data.group?.orgId && data.group?.orgId !== vm.$store.getters.orgId) return;
        if (data.sensitiveWordAuditStatus !== 2) return;
        const previewObject = document.getElementById('preview-object') as HTMLIFrameElement;
        if (!previewObject) return;
        (previewObject as HTMLIFrameElement)?.contentWindow?.postMessage(
          {
            smhAction: 'smhHighlightSearchText',
            smhData: {
              searchWord: text,
            },
          },
          '*',
        );
      },
      messageFun(event: MessageEvent) {
        if (event.data.smhAction === 'documentReady') {
          chooseWord.value = initWord.value;
          methods.changeHighLightText(chooseWord.value);
        }
      },
      mouseEnterTag() {
        if (showNum === 0) {
          showNum++;
          showTips.value = true;
        }
      },
      getDisplayPath(item: SMH.SpaceFileItemData) {
        return i18n_t('全部/{slot1}', { slot1: item.path });
      },
    };
    onMounted(() => methods.initData());
    onUnmounted(() => {
      window.removeEventListener('message', methods.messageFun);
    });
    watch(params, val => {
      if (val) {
        methods.initData();
      }
    });
    window.addEventListener('message', methods.messageFun);
    return {
      isExternalFile,
      dataItem: params,
      detailLoading,
      DetailType,
      BaseDetailType,
      detailItem,
      chooseWord,
      detailData,
      closeable,
      isPreview,
      showTips,
      userData,
      getNameTipsDetail,
      historyVersion,
      ...methods,
    };
  },
});
